// extracted by css-extract-rspack-plugin
export default {"container":"LDspc7AFf8YxwtY8","separator":"UtiQNkqeGNsnxezN","crumb":"k4zFI8kxeHgBPqyr","crumbLink":"lOlcx4XuAoxClZkw","crumbText":"AzJHbzGZYj8CgdKn"};